import { ChevronDownIcon } from '@heroicons/react/outline';
import ReactMarkdown from 'react-markdown';

interface AISummarySectionProps {
  id?: string;
  response: string | undefined;
}

const AISummarySection = ({ id, response }: AISummarySectionProps) => {
  return (
    <details id={id} className="yst-group/summary" open>
      <summary className="yst-flex yst-items-center yst-justify-between yst-cursor-pointer yst-list-none [&::-webkit-details-marker]:yst-hidden yst-mb-4">
        <h3 className="yst-font-semibold">AI Summary</h3>
        <ChevronDownIcon className="yst-h-4 yst-w-4 yst-text-gray-400 yst-flex-shrink-0 group-open/summary:yst-rotate-180 yst-transition-transform" />
      </summary>
      <div className="yst-rounded-lg yst-border yst-border-gray-300 yst-p-4">
        <div className="yst-text-sm yst-text-gray-700 [&_p]:yst-mb-4 [&_ul]:yst-list-disc [&_ul]:yst-ml-6 [&_ul]:yst-mb-4 [&_ol]:yst-list-decimal [&_ol]:yst-ml-6 [&_ol]:yst-mb-4 [&_li]:yst-mb-1 [&_h1]:yst-text-xl [&_h1]:yst-font-bold [&_h1]:yst-mb-2 [&_h2]:yst-text-lg [&_h2]:yst-font-bold [&_h2]:yst-mb-2 [&_h3]:yst-font-bold [&_h3]:yst-mb-2 [&_code]:yst-bg-white [&_code]:yst-px-1 [&_code]:yst-rounded [&_pre]:yst-bg-white [&_pre]:yst-p-3 [&_pre]:yst-rounded [&_pre]:yst-mb-4 [&_pre]:yst-overflow-x-auto [&_p:last-child]:yst-mb-0 [&_ul:last-child]:yst-mb-0 [&_ol:last-child]:yst-mb-0">
          <ReactMarkdown components={{ a: ({ children, href }) => <a href={href} target="_blank" rel="noopener noreferrer">{children}</a> }}>{response || 'No response available'}</ReactMarkdown>
        </div>
      </div>
    </details>
  );
};

export default AISummarySection;
